import {useEffect} from 'react';

export default function useScrollToTop(trigger) {
    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }, [trigger]); // the effect will run every time 'trigger' changes
}